import { CreateReportsModal } from './reports-list-actions-modal'

export const Report19 = () => {
  return (
    <div className="p-12 bg-white content-container">
      <div className="lg:flex-row lg:justify-between gap-2">
        <div>
          <h3>
            <span className="tracking-wider font-bold text-xl">Report 19</span>
          </h3>
          <p>
            <span className="tracking-wider font-light">
              Generate Gift card Sales Summary
            </span>
          </p>
          <br />
        </div>
        <CreateReportsModal />
      </div>
    </div>
  )
}
